module.exports = __webpack_public_path__ + "static/media/logo_long_dark_bg.0d6c005d.png";